export default "__VITE_ASSET__BsU6GX2$__"